var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _vm.actionPageType === "advOnly"
      ? _c(
          "div",
          {
            staticClass:
              "container feedback template-bg-gray email-request-main-section",
            class: { "my-position-relative": _vm.isStatus }
          },
          [
            _vm.isStatus
              ? _c(
                  "md-card",
                  {
                    staticClass:
                      "request-status loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c(
                      "md-card-content",
                      {
                        staticClass:
                          "col-lg-12 col-md-12 col-sm-12 col-xs-12 main"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card form-wrapper text-center p-20" },
                          [
                            _c("h4", {
                              staticClass: "template-custom-title",
                              domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            [
              _c("snackbar", {
                ref: "snackbar",
                attrs: {
                  baseSize: "100px",
                  position: "top-center",
                  wrapClass: "",
                  colors: { open: "#3DBD7D" },
                  holdTime: 5000,
                  multiple: false,
                  "aria-live": "assertive"
                }
              })
            ],
            _vm._v(" "),
            !_vm.isStatus
              ? _c(
                  "div",
                  { staticClass: "row", attrs: { "aria-live": "polite" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "loop_container bg-transparent update-request-form-common",
                            class: { "emailreq-ty": _vm.success }
                          },
                          [
                            _c("div", { staticClass: "card form-wrapper" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "feedback_container feedback_newupdate"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12 text-center" },
                                      [
                                        _c("img", {
                                          staticClass: "top-logo custom-logo",
                                          attrs: {
                                            src: _vm.logoURL,
                                            alt:
                                              "Community Logo of " +
                                              _vm.community.content.parameter2
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.skip === "no"
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.success,
                                              expression: "!success"
                                            }
                                          ],
                                          staticClass:
                                            "row common-space-from-logo"
                                        },
                                        [
                                          _vm.action == "no"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { role: "tablist" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-sm-4 col-xs-12 text-center"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn-block btn template-button help-action-font-15 md-red",
                                                            class: {
                                                              "no-btn-active":
                                                                _vm.currentTab ===
                                                                "no-not-available"
                                                            },
                                                            attrs: {
                                                              type: "submit",
                                                              name:
                                                                "helpAction",
                                                              role: "tab",
                                                              value:
                                                                "Not Available",
                                                              id:
                                                                "notAvailableBtn"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.expandContent(
                                                                  "no",
                                                                  $event.target
                                                                    .textContent
                                                                )
                                                                _vm.currentTab =
                                                                  "no-not-available"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not Available"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-sm-4 col-xs-12 text-center center-button-div"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn-block btn template-button help-action-font-15 md-red",
                                                            class: {
                                                              "no-btn-active":
                                                                _vm.currentTab ===
                                                                "no-not-relevant"
                                                            },
                                                            attrs: {
                                                              type: "submit",
                                                              name:
                                                                "helpAction",
                                                              value:
                                                                "Not Relevant",
                                                              role: "tab"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.expandContent(
                                                                  "no",
                                                                  "Not Relevant"
                                                                )
                                                                _vm.currentTab =
                                                                  "no-not-relevant"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not A Fit For Me"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-sm-4 col-xs-12 text-center"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn-block btn template-button help-action-font-15 md-red",
                                                            class: {
                                                              "no-btn-active":
                                                                _vm.currentTab ===
                                                                "no-not-good-question"
                                                            },
                                                            attrs: {
                                                              type: "submit",
                                                              name:
                                                                "helpAction",
                                                              role: "tab",
                                                              value:
                                                                "Not A Good Question"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.expandContent(
                                                                  "no",
                                                                  $event.target
                                                                    .textContent
                                                                )
                                                                _vm.currentTab =
                                                                  "no-not-good-question"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not A Good Question"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.opened.includes("yes") &&
                                            _vm.action == "yes" &&
                                            !_vm.success,
                                          expression:
                                            "opened.includes('yes') && action == 'yes' && !success"
                                        }
                                      ],
                                      staticClass:
                                        "row email-request-form-container"
                                    },
                                    [
                                      _c(
                                        "form",
                                        {
                                          staticClass: "template-form",
                                          on: {
                                            submit: function($event) {
                                              $event.preventDefault()
                                              return _vm.helpaction(
                                                _vm.actionName
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm.actionName.search(
                                            /Share Advice/i
                                          ) !== -1 ||
                                          (_vm.actionName.search(/Call Me/i) !==
                                            -1 &&
                                            (_vm.memberid === "undefined" ||
                                              typeof _vm.memberid ===
                                                "undefined" ||
                                              _vm.memberid === "null" ||
                                              _vm.memberid === ""))
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row custom-action"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-sm-12"
                                                    },
                                                    [
                                                      _vm.actionName.search(
                                                        /Share Advice/i
                                                      ) !== -1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-center custom-content"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Please enter your response below and we will share it with the requesting member (you will get a copy of the response)."
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.actionName.search(
                                                        /Call Me/i
                                                      ) !== -1 &&
                                                      (_vm.memberid ===
                                                        "undefined" ||
                                                        typeof _vm.memberid ===
                                                          "undefined" ||
                                                        _vm.memberid ===
                                                          "null" ||
                                                        _vm.memberid === "")
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-center custom-content"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Please enter your phone number below and we will forward it to the community member."
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.actionName.search(
                                            /Let's Connect/i
                                          ) !== -1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row custom-action"
                                                },
                                                [_vm._m(0)]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.memberid === "undefined" ||
                                          typeof _vm.memberid === "undefined" ||
                                          _vm.memberid === "null" ||
                                          _vm.memberid === ""
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-lg-6 col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-group remove-formgroup-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "mt-0 template-label"
                                                        },
                                                        [_vm._v("First Name")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              "required|alpha_spaces",
                                                            expression:
                                                              "'required|alpha_spaces'"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.first,
                                                            expression: "first"
                                                          },
                                                          {
                                                            name: "focus",
                                                            rawName: "v-focus"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control input-value",
                                                        attrs: {
                                                          "aria-label":
                                                            "Input, enter your first name",
                                                          type: "text",
                                                          id: "first_yes",
                                                          name:
                                                            "feedback_first",
                                                          placeholder:
                                                            "What's your first name?"
                                                        },
                                                        domProps: {
                                                          value: _vm.first
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.updateSubmitBtnDisabled,
                                                          input: [
                                                            function($event) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.first =
                                                                $event.target.value
                                                            },
                                                            function(e) {
                                                              return (_vm.first = _vm.sanitizeInput(
                                                                e.target.value
                                                              ))
                                                            }
                                                          ]
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "feedback_first"
                                                              ),
                                                              expression:
                                                                "errors.has('feedback_first')"
                                                            }
                                                          ],
                                                          staticClass: "error"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "feedback_first"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.memberid === "undefined" ||
                                          typeof _vm.memberid === "undefined" ||
                                          _vm.memberid === "null" ||
                                          _vm.memberid === ""
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-lg-6 col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-group remove-formgroup-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "mt-0 template-label"
                                                        },
                                                        [_vm._v("Last Name")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              "required|alpha_spaces",
                                                            expression:
                                                              "'required|alpha_spaces'"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.last,
                                                            expression: "last"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control input-value",
                                                        attrs: {
                                                          "aria-label":
                                                            "Input, enter your last name.",
                                                          type: "text",
                                                          id: "last_yes",
                                                          name: "feedback_last",
                                                          placeholder:
                                                            "What's your last name?"
                                                        },
                                                        domProps: {
                                                          value: _vm.last
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.updateSubmitBtnDisabled,
                                                          input: [
                                                            function($event) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.last =
                                                                $event.target.value
                                                            },
                                                            function(e) {
                                                              return (_vm.last = _vm.sanitizeInput(
                                                                e.target.value
                                                              ))
                                                            }
                                                          ]
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "feedback_last"
                                                              ),
                                                              expression:
                                                                "errors.has('feedback_last')"
                                                            }
                                                          ],
                                                          staticClass: "error"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "feedback_last"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.memberid === "undefined" ||
                                          typeof _vm.memberid === "undefined" ||
                                          _vm.memberid === "null" ||
                                          _vm.memberid === ""
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-lg-6 col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-group remove-formgroup-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "mt-0 template-label"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Email Address"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              "required|email|max:60",
                                                            expression:
                                                              "'required|email|max:60'"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.email,
                                                            expression: "email"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control input-value",
                                                        attrs: {
                                                          "aria-label":
                                                            "Input, enter your email address",
                                                          type: "text",
                                                          id: "email_yes",
                                                          name:
                                                            "feedback_email",
                                                          placeholder:
                                                            "What's your email address?"
                                                        },
                                                        domProps: {
                                                          value: _vm.email
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.updateSubmitBtnDisabled,
                                                          input: [
                                                            function($event) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.email =
                                                                $event.target.value
                                                            },
                                                            function(e) {
                                                              return (_vm.email = _vm.sanitizeInput(
                                                                e.target.value
                                                              ))
                                                            }
                                                          ]
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "feedback_email"
                                                              ),
                                                              expression:
                                                                "errors.has('feedback_email')"
                                                            }
                                                          ],
                                                          staticClass: "error"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "feedback_email"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.actionName.search(/Call Me/i) !==
                                            -1 &&
                                          (_vm.memberid === "undefined" ||
                                            typeof _vm.memberid ===
                                              "undefined" ||
                                            _vm.memberid === "null" ||
                                            _vm.memberid === "")
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-sm-6 ml-1"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "template-label"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "What is your phone number?"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.phoneNo,
                                                              expression:
                                                                "phoneNo"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate.continues",
                                                              value:
                                                                "required|numeric",
                                                              expression:
                                                                "'required|numeric'",
                                                              modifiers: {
                                                                continues: true
                                                              }
                                                            },
                                                            {
                                                              name: "focus",
                                                              rawName: "v-focus"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control input-value",
                                                          attrs: {
                                                            "aria-label":
                                                              "Input, enter your phone number",
                                                            type: "text",
                                                            name: "phoneNo",
                                                            placeholder:
                                                              "(999) 999-9999"
                                                          },
                                                          domProps: {
                                                            value: _vm.phoneNo
                                                          },
                                                          on: {
                                                            keyup:
                                                              _vm.updateSubmitBtnDisabled,
                                                            input: [
                                                              function($event) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.phoneNo =
                                                                  $event.target.value
                                                              },
                                                              function(e) {
                                                                return (_vm.phoneNo = _vm.sanitizeInput(
                                                                  e.target.value
                                                                ))
                                                              }
                                                            ]
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "phoneNo"
                                                                ),
                                                                expression:
                                                                  "errors.has('phoneNo')"
                                                              }
                                                            ],
                                                            staticClass: "error"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "phoneNo"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-sm-12" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group disclaimer"
                                                      },
                                                      [
                                                        _c(
                                                          "md-checkbox",
                                                          {
                                                            staticClass:
                                                              "form-control template-checkbox pt-0 my-15",
                                                            attrs: {
                                                              name: "calltext"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.callText,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.callText = $$v
                                                              },
                                                              expression:
                                                                "callText"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Check this box if the individual can text you at this number"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-sm-12" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "template-label"
                                                          },
                                                          [_vm._v("Message")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height"
                                                          },
                                                          [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate.continues",
                                                                  value:
                                                                    "required|max:5000|min:25",
                                                                  expression:
                                                                    "'required|max:5000|min:25'",
                                                                  modifiers: {
                                                                    continues: true
                                                                  }
                                                                },
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.callMessage,
                                                                  expression:
                                                                    "callMessage"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control call-me-height placeholder-bold",
                                                              class: {
                                                                "request-form-error-border": _vm.errors.has(
                                                                  "call-message"
                                                                )
                                                              },
                                                              attrs: {
                                                                "aria-label":
                                                                  "Offer call textarea, character count available",
                                                                "aria-describedby":
                                                                  "char-counter-offercall",
                                                                name:
                                                                  "call-message",
                                                                rows: "20",
                                                                maxlength:
                                                                  _vm.max,
                                                                placeholder:
                                                                  "[Click here to edit] \n" +
                                                                  _vm.actionFormTipsPlaceholder(
                                                                    _vm
                                                                      .community
                                                                      .content
                                                                      .actionFormCallTips
                                                                  )
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.callMessage
                                                              },
                                                              on: {
                                                                keyup: [
                                                                  _vm.countdown,
                                                                  _vm.updateSubmitBtnDisabled
                                                                ],
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.callMessage =
                                                                    $event.target.value
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "char-counter template-subject-counter",
                                                                    class: {
                                                                      "char-count-error":
                                                                        _vm.exceedsMaxCount
                                                                    },
                                                                    attrs: {
                                                                      id:
                                                                        "char-counter-offercall",
                                                                      "aria-live":
                                                                        "polite"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.remainingCount
                                                                      ) +
                                                                        "  / 5000 "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "sr-only"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "characters"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "call-message"
                                                                ),
                                                                expression:
                                                                  "errors.has('call-message')"
                                                              }
                                                            ],
                                                            staticClass: "error"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "call-message"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-sm-12" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group remove-formgroup-margin unsubscribe-btn btn-other text-right"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn template-button submitBtn btn_info",
                                                            style:
                                                              _vm.styleObjectBtn,
                                                            attrs: {
                                                              type: "submit",
                                                              name:
                                                                "helpAction",
                                                              disabled:
                                                                _vm.isSubmitBtnDisabled
                                                            }
                                                          },
                                                          [_vm._v("Submit")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-12" },
                                            [
                                              _vm.actionName.search(
                                                /Share Advice/i
                                              ) !== -1
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group remove-formgroup-margin mt-10"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            ref: "afterClick",
                                                            staticClass:
                                                              "template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height"
                                                          },
                                                          [
                                                            _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate.continues",
                                                                  value:
                                                                    "required|max:5000|min:50",
                                                                  expression:
                                                                    "'required|max:5000|min:50'",
                                                                  modifiers: {
                                                                    continues: true
                                                                  }
                                                                },
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.feedback_comment,
                                                                  expression:
                                                                    "feedback_comment"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control placeholder-bold",
                                                              class: {
                                                                "request-form-error-border": _vm.errors.has(
                                                                  "feedback_comment"
                                                                )
                                                              },
                                                              attrs: {
                                                                name:
                                                                  "feedback_comment",
                                                                "aria-describedby":
                                                                  "char-counter-advice",
                                                                "aria-label":
                                                                  "Write your advice here textarea, character count available",
                                                                rows: "20",
                                                                maxlength:
                                                                  _vm.max,
                                                                placeholder:
                                                                  "[Click here to edit] \n" +
                                                                  _vm.actionFormTipsPlaceholder(
                                                                    _vm
                                                                      .community
                                                                      .content
                                                                      .actionFormAdviceTips
                                                                  )
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.feedback_comment
                                                              },
                                                              on: {
                                                                keyup: [
                                                                  _vm.countdown,
                                                                  _vm.updateSubmitBtnDisabled
                                                                ],
                                                                input: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.feedback_comment =
                                                                      $event.target.value
                                                                  },
                                                                  function(e) {
                                                                    _vm.feedback_comment = _vm.sanitizeInput(
                                                                      e.target
                                                                        .value
                                                                    )
                                                                    _vm.detectContactInfo(
                                                                      _vm.feedback_comment
                                                                    )
                                                                  }
                                                                ]
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "char-counter template-subject-counter",
                                                                    class: {
                                                                      "char-count-error":
                                                                        _vm.exceedsMaxCount
                                                                    },
                                                                    attrs: {
                                                                      id:
                                                                        "char-counter-advice"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.remainingCount
                                                                      ) +
                                                                        "  / 5000 "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "sr-only"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "characters"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.contactInfoDetected ===
                                                        false
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "contact-detection-banner"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "contact-detection-icon"
                                                                  },
                                                                  [_vm._v("!")]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._m(1)
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.errors.has(
                                                          "feedback_comment"
                                                        )
                                                          ? _c(
                                                              "p",
                                                              {
                                                                key: _vm.errors.first(
                                                                  "feedback_comment"
                                                                ),
                                                                staticClass:
                                                                  "error",
                                                                attrs: {
                                                                  role: "alert",
                                                                  "aria-live":
                                                                    "assertive"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "feedback_comment"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12 col-sm-12 text-right"
                                                          },
                                                          [
                                                            _vm.actionName.search(
                                                              /Share Advice/i
                                                            ) !== -1
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form-group remove-formgroup-margin unsubscribe-btn"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "btn template-button",
                                                                        style:
                                                                          _vm.submitStyleObjectBtn,
                                                                        attrs: {
                                                                          "aria-label":
                                                                            "Submit your advice for this individual",
                                                                          tabindex:
                                                                            "0",
                                                                          type:
                                                                            "submit",
                                                                          name:
                                                                            "helpAction",
                                                                          disabled:
                                                                            _vm.isSubmitBtnDisabled
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Submit Advice"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.textError
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "txtError"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "If you have a lot of information to share with the individual, consider offering a call or a meeting. "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.actionName.search(
                                                /Let's Connect/i
                                              ) !== -1
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group unsubscribe-height template-input-text-area common-question-textarea-for-v1-v2 mt-10"
                                                      },
                                                      [
                                                        _c("textarea", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate.continues",
                                                              value:
                                                                "required|max:5000|min:25",
                                                              expression:
                                                                "'required|max:5000|min:25'",
                                                              modifiers: {
                                                                continues: true
                                                              }
                                                            },
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.feedback_comment,
                                                              expression:
                                                                "feedback_comment"
                                                            },
                                                            {
                                                              name: "focus",
                                                              rawName: "v-focus"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control pt-input request-form-question-textarea placeholder-bold",
                                                          class: {
                                                            "request-form-error-border": _vm.errors.has(
                                                              "feedback_comment2"
                                                            )
                                                          },
                                                          attrs: {
                                                            "aria-label":
                                                              "Suggest meeting textarea, character count available",
                                                            "aria-describedby":
                                                              "char-counter-meeting",
                                                            name:
                                                              "feedback_comment2",
                                                            rows: "20",
                                                            maxlength: _vm.max,
                                                            placeholder:
                                                              "[Click here to edit] \n" +
                                                              _vm.actionFormTipsPlaceholder(
                                                                _vm.community
                                                                  .content
                                                                  .actionFormMeetingTips
                                                              )
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.feedback_comment
                                                          },
                                                          on: {
                                                            keyup: [
                                                              _vm.countdown,
                                                              _vm.updateSubmitBtnDisabled
                                                            ],
                                                            input: [
                                                              function($event) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.feedback_comment =
                                                                  $event.target.value
                                                              },
                                                              function(e) {
                                                                _vm.feedback_comment = _vm.sanitizeInput(
                                                                  e.target.value
                                                                )
                                                                _vm.detectContactInfo(
                                                                  _vm.feedback_comment
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "char-counter template-subject-counter",
                                                                class: {
                                                                  "char-count-error":
                                                                    _vm.exceedsMaxCount
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "char-counter-meeting",
                                                                  "aria-live":
                                                                    "polite"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.remainingCount
                                                                  ) +
                                                                    "  / 5000 "
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "sr-only"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "characters"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "feedback_comment2"
                                                                ),
                                                                expression:
                                                                  "errors.has('feedback_comment2')"
                                                              }
                                                            ],
                                                            key: _vm.errors.first(
                                                              "feedback_comment2"
                                                            ),
                                                            staticClass:
                                                              "error",
                                                            attrs: {
                                                              role: "alert",
                                                              "aria-live":
                                                                "assertive"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "feedback_comment2"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.contactInfoDetected ===
                                                    false
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-detection-banner"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "contact-detection-icon"
                                                              },
                                                              [_vm._v("!")]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._m(2)
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12 col-sm-12 text-right"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form-group remove-formgroup-margin unsubscribe-btn"
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn submitBtn template-button",
                                                                    style:
                                                                      _vm.styleObjectBtn,
                                                                    attrs: {
                                                                      tabindex:
                                                                        "0",
                                                                      type:
                                                                        "submit",
                                                                      name:
                                                                        "helpAction",
                                                                      disabled:
                                                                        _vm.isSubmitBtnDisabled
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Submit Advice"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.opened.includes("no") &&
                                  _vm.action == "no"
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.success,
                                              expression: "!success"
                                            }
                                          ],
                                          staticClass:
                                            "row email-actionpage-content"
                                        },
                                        [
                                          _c(
                                            "form",
                                            {
                                              staticClass: "template-form",
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.helpaction(
                                                    _vm.buttonText
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-12" },
                                                [
                                                  _vm.buttonText.search(
                                                    /Not Available/i
                                                  ) !== -1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center mb-20 email-actionpage-upadate-inner not-available-heading my-15"
                                                        },
                                                        [
                                                          _c(
                                                            "h2",
                                                            [
                                                              _vm._v(
                                                                "\n                                                Thanks for letting us know.\n                                                "
                                                              ),
                                                              _vm.memberid !==
                                                                "undefined" &&
                                                              typeof _vm.memberid !==
                                                                "undefined" &&
                                                              _vm.memberid !==
                                                                "null" &&
                                                              _vm.memberid !==
                                                                ""
                                                                ? [
                                                                    _vm._v(
                                                                      "\n                                                    You can now close this window.\n                                                "
                                                                    )
                                                                  ]
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c("hr", {
                                                            staticClass:
                                                              "not-available-hr"
                                                          }),
                                                          _vm._v(" "),
                                                          _vm.memberid !==
                                                            "undefined" &&
                                                          typeof _vm.memberid !==
                                                            "undefined" &&
                                                          _vm.memberid !==
                                                            "null" &&
                                                          _vm.memberid !== ""
                                                            ? _c("div", [
                                                                _c(
                                                                  "h2",
                                                                  {
                                                                    staticClass:
                                                                      "boldheading"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Know someone else who could help?"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("p", [
                                                                  _vm._v(
                                                                    "Please let us know below and we will forward the request on your behalf.\n                                                    Note that we will not use your contact's information for any other purposes."
                                                                  )
                                                                ])
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.buttonText.search(
                                                    /Not Relevant/i
                                                  ) !== -1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center mb-20 email-actionpage-upadate-inner not-available-heading my-15"
                                                        },
                                                        [
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Thanks for letting us know."
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.memberid !==
                                                            "undefined" &&
                                                          typeof _vm.memberid !==
                                                            "undefined" &&
                                                          _vm.memberid !==
                                                            "null" &&
                                                          _vm.memberid !== ""
                                                            ? [
                                                                _c("br"),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "h1",
                                                                  {
                                                                    staticClass:
                                                                      "white-space-content"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    Please update your profile on "
                                                                    ),
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "link inline-block",
                                                                        attrs: {
                                                                          target:
                                                                            "_blank",
                                                                          href:
                                                                            _vm
                                                                              .community
                                                                              .communitySite
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            this
                                                                              .community
                                                                              .communitySite
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                                    so that we can better match you to requests.\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("hr"),
                                                          _vm._v(" "),
                                                          _vm.memberid !==
                                                            "undefined" &&
                                                          typeof _vm.memberid !==
                                                            "undefined" &&
                                                          _vm.memberid !==
                                                            "null" &&
                                                          _vm.memberid !== ""
                                                            ? _c("div", [
                                                                _c(
                                                                  "h2",
                                                                  {
                                                                    staticClass:
                                                                      "boldheading"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Know someone else who could help?"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("p", [
                                                                  _vm._v(
                                                                    "Please let us know below and we will forward the request on your behalf.\n                                                    Note that we will not use your contact's information for any other purposes."
                                                                  )
                                                                ])
                                                              ])
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.buttonText.search(
                                                    /Not A Good Question/i
                                                  ) !== -1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center mb-20 email-actionpage-upadate-inner not-available-heading my-15"
                                                        },
                                                        [
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Thanks for letting us know."
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Why do you feel that this is not a good question?"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _vm.buttonText.search(
                                                        /Not A Good Question/i
                                                      ) !== -1 &&
                                                      typeof this.memberid !==
                                                        "undefined" &&
                                                      this.memberid !==
                                                        "undefined" &&
                                                      this.memberid !==
                                                        "null" &&
                                                      this.memberid !== ""
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-6 col-sm-offset-3 req-page-select"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-5 create-rule"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        for:
                                                                          "reason-select-1",
                                                                        id:
                                                                          "reason-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        Select a reason\n                                                    "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedResponse,
                                                                          expression:
                                                                            "selectedResponse"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "form-control placeholder-color roboto-slab-class",
                                                                      attrs: {
                                                                        id:
                                                                          "reason-select-1",
                                                                        "aria-labelledby":
                                                                          "reason-label",
                                                                        "aria-expanded": _vm.isExpanded.toString()
                                                                      },
                                                                      on: {
                                                                        change: [
                                                                          function(
                                                                            $event
                                                                          ) {
                                                                            var $$selectedVal = Array.prototype.filter
                                                                              .call(
                                                                                $event
                                                                                  .target
                                                                                  .options,
                                                                                function(
                                                                                  o
                                                                                ) {
                                                                                  return o.selected
                                                                                }
                                                                              )
                                                                              .map(
                                                                                function(
                                                                                  o
                                                                                ) {
                                                                                  var val =
                                                                                    "_value" in
                                                                                    o
                                                                                      ? o._value
                                                                                      : o.value
                                                                                  return val
                                                                                }
                                                                              )
                                                                            _vm.selectedResponse = $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          },
                                                                          function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.submitNegativeResponse(
                                                                              _vm.buttonText,
                                                                              _vm.selectedResponse
                                                                            )
                                                                          }
                                                                        ]
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          staticStyle: {
                                                                            display:
                                                                              "none"
                                                                          },
                                                                          attrs: {
                                                                            value:
                                                                              "",
                                                                            disabled:
                                                                              "",
                                                                            selected:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                            Please select a reason\n                                                        "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._l(
                                                                        _vm.responsesArr,
                                                                        function(
                                                                          reason,
                                                                          index
                                                                        ) {
                                                                          return _c(
                                                                            "option",
                                                                            {
                                                                              key: index,
                                                                              domProps: {
                                                                                value: reason
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            " +
                                                                                  _vm._s(
                                                                                    reason
                                                                                  ) +
                                                                                  "\n                                                        "
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm.buttonText.search(
                                                            /Not A Good Question/i
                                                          ) !== -1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-6 col-sm-offset-3 mb-20 req-page-select"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-5 create-rule"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                      attrs: {
                                                                        for:
                                                                          "reason-select-2",
                                                                        id:
                                                                          "reason-label-2"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        Select a reason\n                                                    "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedResponse,
                                                                          expression:
                                                                            "selectedResponse"
                                                                        },
                                                                        {
                                                                          name:
                                                                            "validate",
                                                                          rawName:
                                                                            "v-validate",
                                                                          value:
                                                                            "required",
                                                                          expression:
                                                                            "'required'"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "form-control placeholder-color roboto-slab-class",
                                                                      attrs: {
                                                                        id:
                                                                          "reason-select-2",
                                                                        name:
                                                                          "reason",
                                                                        "aria-describedby": _vm.errors.has(
                                                                          "reason"
                                                                        )
                                                                          ? "error-reason"
                                                                          : null,
                                                                        "aria-labelledby":
                                                                          "reason-label-2",
                                                                        "aria-expanded": _vm.isExpanded.toString()
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          var $$selectedVal = Array.prototype.filter
                                                                            .call(
                                                                              $event
                                                                                .target
                                                                                .options,
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                return o.selected
                                                                              }
                                                                            )
                                                                            .map(
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                var val =
                                                                                  "_value" in
                                                                                  o
                                                                                    ? o._value
                                                                                    : o.value
                                                                                return val
                                                                              }
                                                                            )
                                                                          _vm.selectedResponse = $event
                                                                            .target
                                                                            .multiple
                                                                            ? $$selectedVal
                                                                            : $$selectedVal[0]
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          staticStyle: {
                                                                            display:
                                                                              "none"
                                                                          },
                                                                          attrs: {
                                                                            value:
                                                                              "",
                                                                            disabled:
                                                                              "",
                                                                            selected:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                            Please select a reason\n                                                        "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._l(
                                                                        _vm.responsesArr,
                                                                        function(
                                                                          reason,
                                                                          index
                                                                        ) {
                                                                          return _c(
                                                                            "option",
                                                                            {
                                                                              key: index,
                                                                              domProps: {
                                                                                value: reason
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            " +
                                                                                  _vm._s(
                                                                                    reason
                                                                                  ) +
                                                                                  "\n                                                        "
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    2
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value: _vm.errors.has(
                                                                            "reason"
                                                                          ),
                                                                          expression:
                                                                            "errors.has('reason')"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "error m-left-5",
                                                                      attrs: {
                                                                        id:
                                                                          "error-reason"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            _vm.errors.first(
                                                                              "reason"
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.memberid ===
                                                    "undefined" ||
                                                  typeof _vm.memberid ===
                                                    "undefined" ||
                                                  _vm.memberid === "null" ||
                                                  _vm.memberid === ""
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-lg-6 col-md-8 col-sm-8"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group remove-formgroup-margin"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "template-label"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "First Name"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|alpha_spaces",
                                                                        expression:
                                                                          "'required|alpha_spaces'"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.first,
                                                                        expression:
                                                                          "first"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "focus",
                                                                        rawName:
                                                                          "v-focus"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control input-value",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      id:
                                                                        "first_no",
                                                                      name:
                                                                        "feedback_first",
                                                                      placeholder:
                                                                        "What's your first name?"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.first
                                                                    },
                                                                    on: {
                                                                      keyup:
                                                                        _vm.updateSubmitBtnDisabled,
                                                                      input: [
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.first =
                                                                            $event.target.value
                                                                        },
                                                                        function(
                                                                          e
                                                                        ) {
                                                                          return (_vm.first = _vm.sanitizeInput(
                                                                            e
                                                                              .target
                                                                              .value
                                                                          ))
                                                                        }
                                                                      ]
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value: _vm.errors.has(
                                                                            "feedback_first"
                                                                          ),
                                                                          expression:
                                                                            "errors.has('feedback_first')"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.errors.first(
                                                                            "feedback_first"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-lg-6 col-md-8 col-sm-8"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group remove-formgroup-margin"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "template-label"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Last Name"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|alpha_spaces",
                                                                        expression:
                                                                          "'required|alpha_spaces'"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.last,
                                                                        expression:
                                                                          "last"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control input-value",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      id:
                                                                        "last_no",
                                                                      name:
                                                                        "feedback_last",
                                                                      placeholder:
                                                                        "What's your last name?"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.last
                                                                    },
                                                                    on: {
                                                                      keyup:
                                                                        _vm.updateSubmitBtnDisabled,
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.last =
                                                                          $event.target.value
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value: _vm.errors.has(
                                                                            "feedback_last"
                                                                          ),
                                                                          expression:
                                                                            "errors.has('feedback_last')"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.errors.first(
                                                                            "feedback_last"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.memberid ===
                                                    "undefined" ||
                                                  typeof _vm.memberid ===
                                                    "undefined" ||
                                                  _vm.memberid === "null" ||
                                                  _vm.memberid === ""
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-lg-6 col-md-8 col-sm-8"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group remove-formgroup-margin"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "template-label"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Email Address"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|email|max:60",
                                                                        expression:
                                                                          "'required|email|max:60'"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.email,
                                                                        expression:
                                                                          "email"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control input-value",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      id:
                                                                        "email_no",
                                                                      name:
                                                                        "feedback_email",
                                                                      placeholder:
                                                                        "What's your email address?"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.email
                                                                    },
                                                                    on: {
                                                                      keyup:
                                                                        _vm.updateSubmitBtnDisabled,
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.email =
                                                                          $event.target.value
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value: _vm.errors.has(
                                                                            "feedback_email"
                                                                          ),
                                                                          expression:
                                                                            "errors.has('feedback_email')"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.errors.first(
                                                                            "feedback_email"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.memberid === "undefined" ||
                                              typeof _vm.memberid ===
                                                "undefined" ||
                                              _vm.memberid === "null" ||
                                              _vm.memberid === ""
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-sm-12"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-group remove-formgroup-margin unsubscribe-btn btn-other"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn template-button submitBtn",
                                                              style:
                                                                _vm.styleObjectBtn,
                                                              attrs: {
                                                                type: "submit",
                                                                name:
                                                                  "helpAction"
                                                              }
                                                            },
                                                            [_vm._v("Submit")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.action === "yes" &&
                                  _vm.buttonText.search(/Call Me/i) !== -1 &&
                                  _vm.memberid !== "undefined" &&
                                    typeof _vm.memberid !== "undefined" &&
                                    _vm.memberid !== "null" &&
                                    _vm.memberid !== ""
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.success,
                                              expression: "!success"
                                            }
                                          ],
                                          staticClass:
                                            "row email-request-form-container"
                                        },
                                        [
                                          _c(
                                            "form",
                                            {
                                              staticClass: "template-form",
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.helpaction(
                                                    _vm.buttonText
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._m(3),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-6" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "template-label"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "What is your phone number?"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.phoneNo,
                                                            expression:
                                                              "phoneNo"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate.continues",
                                                            value:
                                                              "required|numeric",
                                                            expression:
                                                              "'required|numeric'",
                                                            modifiers: {
                                                              continues: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control input-value placeholder-bold",
                                                        attrs: {
                                                          "aria-describedby":
                                                            "phone-example",
                                                          "aria-label":
                                                            "Phone number input",
                                                          type: "tel",
                                                          autocomplete: "tel",
                                                          name: "phoneNo",
                                                          placeholder:
                                                            "(999) 999-9999"
                                                        },
                                                        domProps: {
                                                          value: _vm.phoneNo
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.updateSubmitBtnDisabled,
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.phoneNo =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "sr-only",
                                                          attrs: {
                                                            id: "phone-example"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    Example format: area code, followed by a three-digit prefix, and a four-digit line number.\n                                                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "phoneNo"
                                                              ),
                                                              expression:
                                                                "errors.has('phoneNo')"
                                                            }
                                                          ],
                                                          staticClass: "error"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "phoneNo"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-12" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "template-label"
                                                        },
                                                        [_vm._v("Message")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height"
                                                        },
                                                        [
                                                          _c("textarea", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate.continues",
                                                                value:
                                                                  "required|max:5000|min:25",
                                                                expression:
                                                                  "'required|max:5000|min:25'",
                                                                modifiers: {
                                                                  continues: true
                                                                }
                                                              },
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.callMessage,
                                                                expression:
                                                                  "callMessage"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control call-me-height placeholder-bold",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "call-message"
                                                              )
                                                            },
                                                            attrs: {
                                                              "aria-label":
                                                                "Message textarea, character count available.",
                                                              "aria-describedby":
                                                                "character-count-message",
                                                              name:
                                                                "call-message",
                                                              rows: "20",
                                                              maxlength:
                                                                _vm.max,
                                                              placeholder:
                                                                "[Click here to edit] \n" +
                                                                _vm.actionFormTipsPlaceholder(
                                                                  _vm.community
                                                                    .content
                                                                    .actionFormCallTips
                                                                )
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.callMessage
                                                            },
                                                            on: {
                                                              keyup: [
                                                                _vm.countdown,
                                                                _vm.updateSubmitBtnDisabled
                                                              ],
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.callMessage =
                                                                  $event.target.value
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "char-counter template-subject-counter",
                                                                  class: {
                                                                    "char-count-error":
                                                                      _vm.exceedsMaxCount
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "character-count-message",
                                                                    "aria-live":
                                                                      "polite"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.remainingCount
                                                                    ) +
                                                                      "  / 5000 "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "characters"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "call-message"
                                                              ),
                                                              expression:
                                                                "errors.has('call-message')"
                                                            }
                                                          ],
                                                          staticClass: "error"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "call-message"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-sm-12 text-right"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-group remove-formgroup-margin unsubscribe-btn btn-other text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn template-button btn_info",
                                                          style:
                                                            _vm.submitStyleObjectBtn,
                                                          attrs: {
                                                            type: "submit",
                                                            name: "helpAction",
                                                            disabled:
                                                              _vm.isSubmitBtnDisabled
                                                          }
                                                        },
                                                        [_vm._v("Submit")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.success && _vm.action == "yes") ||
                                  (_vm.successReferral == true &&
                                    _vm.action == "no") ||
                                  (_vm.success &&
                                    _vm.successReferral === false &&
                                    _vm.action == "no" &&
                                    (_vm.memberid === "undefined" ||
                                      typeof _vm.memberid === "undefined" ||
                                      _vm.memberid === "null" ||
                                      _vm.memberid === ""))
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 text-center common-space-from-logo"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "header-text text-center unsubscribepage-thankumsg",
                                                class: {
                                                  "email-actionpage-tmsg": !_vm.success
                                                }
                                              },
                                              [
                                                _c(
                                                  "h1",
                                                  {
                                                    key: _vm.successMsg,
                                                    staticClass:
                                                      "template-title mt-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.successMsg)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                typeof this.memberid !==
                                                  "undefined" &&
                                                this.memberid !== "undefined" &&
                                                this.memberid !== "null" &&
                                                this.memberid !== "" &&
                                                !_vm.emailUpdate
                                                  ? _c("div", [
                                                      _vm.isProfileValidation &&
                                                      !_vm.isEmailSection &
                                                        _vm.isUpdateProfileFlag
                                                        ? _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "click-outside",
                                                                  rawName:
                                                                    "v-click-outside",
                                                                  value:
                                                                    _vm.outside,
                                                                  expression:
                                                                    "outside"
                                                                }
                                                              ]
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "custom-content"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "We matched you to this request based on the below  information. Is this still correct?"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.adviser
                                                                .profileValidationFlag ==
                                                              _vm
                                                                .configureFields
                                                                .profileUpdateInterest
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "custom-content"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Please choose (or remove) interests that we may use to match you to relevant requests."
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.adviser
                                                                      .profileValidationFlag ==
                                                                    _vm
                                                                      .configureFields
                                                                      .profileUpdateInterest
                                                                      ? "interest-div"
                                                                      : "emailreq-profileupdate"
                                                                },
                                                                [
                                                                  _vm.adviser
                                                                    .profileValidationFlag ==
                                                                  _vm
                                                                    .configureFields
                                                                    .profileUpdateOccupation
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm.isEditing &&
                                                                          _vm
                                                                            .community
                                                                            .communityPortal ==
                                                                            "protopia"
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-2 col-xs-4 update-profile-response-label"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Role:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-xs-8"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  directives: [
                                                                                                    {
                                                                                                      name:
                                                                                                        "focus",
                                                                                                      rawName:
                                                                                                        "v-focus"
                                                                                                    }
                                                                                                  ],
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    "aria-describedby":
                                                                                                      "role-description",
                                                                                                    name:
                                                                                                      "memberRoles"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .memberRoles,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "memberRoles",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.memberRoles"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "role-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your role.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row py-10"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-2 col-xs-4 update-profile-response-label"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Organization:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-xs-8"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    "aria-describedby":
                                                                                                      "org-description",
                                                                                                    name:
                                                                                                      "organization"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .organization,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "organization",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.organization"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "org-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your organization name.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm.adviser
                                                                    .profileValidationFlag ==
                                                                  _vm
                                                                    .configureFields
                                                                    .profileUpdateInterest
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mb-0"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row text-center my"
                                                                            },
                                                                            [
                                                                              _vm._l(
                                                                                _vm.randomInterest,
                                                                                function(
                                                                                  randomInterestItem
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        key: randomInterestItem,
                                                                                        staticClass:
                                                                                          "col-md-4 col-sm-4 col-xs-6 width100"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "md-checkbox",
                                                                                          {
                                                                                            key: randomInterestItem,
                                                                                            staticClass:
                                                                                              "my-round-checkbox",
                                                                                            attrs: {
                                                                                              value: randomInterestItem,
                                                                                              name: randomInterestItem
                                                                                            },
                                                                                            model: {
                                                                                              value:
                                                                                                _vm.selectedInterestList,
                                                                                              callback: function(
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.selectedInterestList = $$v
                                                                                              },
                                                                                              expression:
                                                                                                "selectedInterestList"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                randomInterestItem
                                                                                              )
                                                                                            ),
                                                                                            _c(
                                                                                              "md-tooltip",
                                                                                              {
                                                                                                attrs: {
                                                                                                  "md-direction":
                                                                                                    "right"
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    randomInterestItem
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              )
                                                                            ],
                                                                            2
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm.adviser
                                                                    .profileValidationFlag ==
                                                                  _vm
                                                                    .configureFields
                                                                    .profileUpdateGeography
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm.isEditing &&
                                                                          _vm
                                                                            .community
                                                                            .communityPortal ==
                                                                            "protopia"
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _vm._m(
                                                                                        4
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-xs-8"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  directives: [
                                                                                                    {
                                                                                                      name:
                                                                                                        "focus",
                                                                                                      rawName:
                                                                                                        "v-focus"
                                                                                                    }
                                                                                                  ],
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "city-input-custom",
                                                                                                    "aria-describedby":
                                                                                                      "city-description",
                                                                                                    name:
                                                                                                      "city"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .city,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "city",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.city"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "city-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your city.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row py-10"
                                                                                    },
                                                                                    [
                                                                                      _vm._m(
                                                                                        5
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-xs-8"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "state-input-custom",
                                                                                                    "aria-describedby":
                                                                                                      "state-description",
                                                                                                    name:
                                                                                                      "state"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .state,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "state",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.state"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "state-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your state.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _vm._m(
                                                                                        6
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-xs-8"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "country-input-custom",
                                                                                                    "aria-describedby":
                                                                                                      "country-description",
                                                                                                    name:
                                                                                                      "country"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .country,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "country",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.country"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "country-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your country.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm.adviser
                                                                    .profileValidationFlag ==
                                                                  _vm
                                                                    .configureFields
                                                                    .profileUpdatePhoneNumber
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row",
                                                                              staticStyle: {
                                                                                display:
                                                                                  "flex"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-1 col-sm-1 update-profile-response-label width100",
                                                                                  staticStyle: {
                                                                                    width:
                                                                                      "auto",
                                                                                    "white-space":
                                                                                      "nowrap"
                                                                                  },
                                                                                  attrs: {
                                                                                    "aria-live":
                                                                                      "polite"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Phone Number:"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-11 col-sm-11"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "focus",
                                                                                              rawName:
                                                                                                "v-focus"
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            "aria-describedby":
                                                                                              "phonenumber-description",
                                                                                            name:
                                                                                              "phoneNumbers"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .phoneNumbers[0],
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .memberObj
                                                                                                  .phoneNumbers,
                                                                                                0,
                                                                                                typeof $$v ===
                                                                                                  "string"
                                                                                                  ? $$v.trim()
                                                                                                  : $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.phoneNumbers[0]"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "phonenumber-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                            Please enter your phone number.\n                                                                        "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm.adviser
                                                                    .profileValidationFlag ==
                                                                  _vm
                                                                    .configureFields
                                                                    .profileUpdateLinkedInUrl
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm.isEditing &&
                                                                          _vm
                                                                            .community
                                                                            .communityPortal ==
                                                                            "protopia"
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row",
                                                                                      staticStyle: {
                                                                                        display:
                                                                                          "flex"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-2 col-sm-2 update-profile-response-label width100",
                                                                                          staticStyle: {
                                                                                            width:
                                                                                              "auto",
                                                                                            "white-space":
                                                                                              "nowrap"
                                                                                          },
                                                                                          attrs: {
                                                                                            "aria-live":
                                                                                              "polite"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "LinkedIn Url:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-lg-10 col-sm-10"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "md-field",
                                                                                            {
                                                                                              staticClass:
                                                                                                "profileValidation"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "md-input",
                                                                                                {
                                                                                                  directives: [
                                                                                                    {
                                                                                                      name:
                                                                                                        "focus",
                                                                                                      rawName:
                                                                                                        "v-focus"
                                                                                                    }
                                                                                                  ],
                                                                                                  staticClass:
                                                                                                    "d-block-w-100 update-profile-template-input",
                                                                                                  attrs: {
                                                                                                    "aria-describedby":
                                                                                                      "linkedIn-description",
                                                                                                    name:
                                                                                                      "linkedIn"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      _vm.saveChanges
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .memberObj
                                                                                                        .linkedIn,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm.memberObj,
                                                                                                        "linkedIn",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "memberObj.linkedIn"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "sr-only",
                                                                                                  attrs: {
                                                                                                    id:
                                                                                                      "linkedIn-description"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                                            Please enter your LinkedIn profile URL.\n                                                                        "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "btn-block"
                                                                },
                                                                [
                                                                  _vm.community
                                                                    .communityPortal ==
                                                                  "linkedin"
                                                                    ? _c(
                                                                        "button",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "focus",
                                                                              rawName:
                                                                                "v-focus"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "btn linkedin-btn",
                                                                          attrs: {
                                                                            type:
                                                                              "button"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.clickUpdateProfile(
                                                                                true
                                                                              ),
                                                                                _vm.saveProfile(
                                                                                  "blank"
                                                                                ),
                                                                                _vm.updateLinkedinProfile
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Update from LinkedIn"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "btn-block"
                                                                },
                                                                [
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn template-button btn-lightbg",
                                                                      style:
                                                                        _vm.nextCloseBtn,
                                                                      attrs: {
                                                                        type:
                                                                          "button"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.goToNext()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Next"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "h-54"
                                                              })
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.isEmailSection,
                                                              expression:
                                                                "isEmailSection"
                                                            }
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "my-text-center"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Would you like to adjust how often we ask you for help with requests matching your profile?"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-md-12 text-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "progressbar-block my"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ul",
                                                                        {
                                                                          staticClass:
                                                                            "progressbar",
                                                                          attrs: {
                                                                            role:
                                                                              "radiogroup",
                                                                            "aria-labelledby":
                                                                              "email-frequency-label",
                                                                            "aria-live":
                                                                              "polite"
                                                                          },
                                                                          on: {
                                                                            keydown:
                                                                              _vm.handleArrowKeys
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "sr-only",
                                                                              attrs: {
                                                                                id:
                                                                                  "email-frequency-label"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Select email frequency"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "li",
                                                                            {
                                                                              class: {
                                                                                success:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ==
                                                                                  "as often as needed"
                                                                              },
                                                                              attrs: {
                                                                                tabindex:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "as often as needed"
                                                                                    ? 0
                                                                                    : -1,
                                                                                role:
                                                                                  "radio",
                                                                                "aria-checked":
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "as often as needed"
                                                                              },
                                                                              on: {
                                                                                keydown: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "enter",
                                                                                      13,
                                                                                      $event.key,
                                                                                      "Enter"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "space",
                                                                                      32,
                                                                                      $event.key,
                                                                                      [
                                                                                        " ",
                                                                                        "Spacebar"
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "as often as needed"
                                                                                  )
                                                                                },
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "as often as needed"
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    "All"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm.frequency ==
                                                                              "as often as needed"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "success-text"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(active)"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "li",
                                                                            {
                                                                              class: {
                                                                                success:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ==
                                                                                  "daily"
                                                                              },
                                                                              attrs: {
                                                                                tabindex:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "daily"
                                                                                    ? 0
                                                                                    : -1,
                                                                                role:
                                                                                  "radio",
                                                                                "aria-checked":
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "daily"
                                                                              },
                                                                              on: {
                                                                                keydown: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "enter",
                                                                                      13,
                                                                                      $event.key,
                                                                                      "Enter"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "space",
                                                                                      32,
                                                                                      $event.key,
                                                                                      [
                                                                                        " ",
                                                                                        "Spacebar"
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "daily"
                                                                                  )
                                                                                },
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "daily"
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Daily"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm.frequency ==
                                                                              "daily"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "success-text"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(active)"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "li",
                                                                            {
                                                                              class: {
                                                                                success:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ==
                                                                                  "once a week"
                                                                              },
                                                                              attrs: {
                                                                                tabindex:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a week"
                                                                                    ? 0
                                                                                    : -1,
                                                                                role:
                                                                                  "radio",
                                                                                "aria-checked":
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a week"
                                                                              },
                                                                              on: {
                                                                                keydown: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "enter",
                                                                                      13,
                                                                                      $event.key,
                                                                                      "Enter"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "space",
                                                                                      32,
                                                                                      $event.key,
                                                                                      [
                                                                                        " ",
                                                                                        "Spacebar"
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a week"
                                                                                  )
                                                                                },
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a week"
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Weekly"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm.frequency ==
                                                                              "once a week"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "success-text"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(active)"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "li",
                                                                            {
                                                                              class: {
                                                                                success:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ==
                                                                                  "once a month"
                                                                              },
                                                                              attrs: {
                                                                                tabindex:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a month"
                                                                                    ? 0
                                                                                    : -1,
                                                                                role:
                                                                                  "radio",
                                                                                "aria-checked":
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a month"
                                                                              },
                                                                              on: {
                                                                                keydown: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "enter",
                                                                                      13,
                                                                                      $event.key,
                                                                                      "Enter"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "space",
                                                                                      32,
                                                                                      $event.key,
                                                                                      [
                                                                                        " ",
                                                                                        "Spacebar"
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a month"
                                                                                  )
                                                                                },
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a month"
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Monthly"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm.frequency ==
                                                                              "once a month"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "success-text"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(active)"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "li",
                                                                            {
                                                                              class: {
                                                                                success:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ==
                                                                                  "once a quarter"
                                                                              },
                                                                              attrs: {
                                                                                tabindex:
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a quarter"
                                                                                    ? 0
                                                                                    : -1,
                                                                                role:
                                                                                  "radio",
                                                                                "aria-checked":
                                                                                  _vm
                                                                                    .adviser
                                                                                    .frequency ===
                                                                                  "once a quarter"
                                                                              },
                                                                              on: {
                                                                                keydown: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    !$event.type.indexOf(
                                                                                      "key"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "enter",
                                                                                      13,
                                                                                      $event.key,
                                                                                      "Enter"
                                                                                    ) &&
                                                                                    _vm._k(
                                                                                      $event.keyCode,
                                                                                      "space",
                                                                                      32,
                                                                                      $event.key,
                                                                                      [
                                                                                        " ",
                                                                                        "Spacebar"
                                                                                      ]
                                                                                    )
                                                                                  ) {
                                                                                    return null
                                                                                  }
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a quarter"
                                                                                  )
                                                                                },
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.changeEmailFrequency(
                                                                                    "once a quarter"
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Quarterly"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm.frequency ==
                                                                              "once a quarter"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "success-text"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "(active)"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "btn-block"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn template-button btn-darkbg mb_0",
                                                                  style:
                                                                    _vm.emailBtn,
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    tabindex:
                                                                      "0"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateEmailFrequency()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Submit"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "btn-block"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn template-button btn-lightbg",
                                                                  style:
                                                                    _vm.nextCloseBtn,
                                                                  attrs: {
                                                                    tabindex:
                                                                      "0",
                                                                    type:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.closeBtn()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Close"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "h-54"
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            (_vm.successReferral === false &&
                                              _vm.success === false &&
                                              _vm.action === "no" &&
                                              (_vm.buttonText.search(
                                                /Not Available/i
                                              ) !== -1 ||
                                                _vm.buttonText.search(
                                                  /Not Relevant/i
                                                ) !== -1 ||
                                                _vm.buttonText.search(
                                                  /Not A Good Question/i
                                                ) !== -1) &&
                                              _vm.memberid != "undefined" &&
                                                typeof _vm.memberid !=
                                                  "undefined" &&
                                                _vm.memberid != "null" &&
                                                _vm.memberid != "") ||
                                            (_vm.skip == "yes" &&
                                              _vm.successReferral === false),
                                          expression:
                                            "(successReferral === false && success === false && action === 'no' && (buttonText.search(/Not Available/i) !== -1 || buttonText.search(/Not Relevant/i) !== -1 || buttonText.search(/Not A Good Question/i) !== -1)  && (memberid != 'undefined' && typeof memberid != 'undefined' && memberid != 'null' && memberid != '') || ( skip == 'yes' && successReferral === false))"
                                        }
                                      ],
                                      staticClass: "nofeedback"
                                    },
                                    [
                                      _vm.buttonText.search(
                                        /Not Available/i
                                      ) !== -1
                                        ? _c(
                                            "form",
                                            {
                                              staticClass: "template-form",
                                              attrs: {
                                                "data-vv-scope": "referral"
                                              },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.submitReferral(
                                                    "referral"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _vm._m(7),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 nofeedback-customspace mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label"
                                                            },
                                                            [_vm._v("Name")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.referral
                                                                    .recipient
                                                                    .name,
                                                                expression:
                                                                  "referral.recipient.name",
                                                                modifiers: {
                                                                  trim: true
                                                                }
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              },
                                                              {
                                                                name: "focus",
                                                                rawName:
                                                                  "v-focus"
                                                              }
                                                            ],
                                                            ref:
                                                              "recipient_name",
                                                            staticClass:
                                                              "form-control input-value",
                                                            attrs: {
                                                              "aria-describedby":
                                                                "recipient_name_error",
                                                              type: "text",
                                                              name:
                                                                "recipient_name"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.referral
                                                                  .recipient
                                                                  .name
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.referral
                                                                    .recipient,
                                                                  "name",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "referral.recipient_name"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('referral.recipient_name')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error",
                                                              attrs: {
                                                                id:
                                                                  "recipient_name_error"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "referral.recipient_name"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 nofeedback-customspace mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label"
                                                            },
                                                            [_vm._v("Email:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.referral
                                                                    .recipient
                                                                    .email,
                                                                expression:
                                                                  "referral.recipient.email",
                                                                modifiers: {
                                                                  trim: true
                                                                }
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required|email",
                                                                expression:
                                                                  "'required|email'"
                                                              }
                                                            ],
                                                            ref:
                                                              "recipient_email",
                                                            staticClass:
                                                              "form-control input-value",
                                                            attrs: {
                                                              name:
                                                                "recipient_email",
                                                              id:
                                                                "recipient_email",
                                                              "aria-describedby":
                                                                "recipient_email_error",
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.referral
                                                                  .recipient
                                                                  .email
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.referral
                                                                    .recipient,
                                                                  "email",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "referral.recipient_email"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('referral.recipient_email')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error",
                                                              attrs: {
                                                                id:
                                                                  "recipient_email_error"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "referral.recipient_email"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _vm._m(8),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 nofeedback-customspace mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for:
                                                                  "adviser_name"
                                                              }
                                                            },
                                                            [_vm._v("Name:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.referral
                                                                    .adviser
                                                                    .name,
                                                                expression:
                                                                  "referral.adviser.name",
                                                                modifiers: {
                                                                  trim: true
                                                                }
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            ref: "adviser_name",
                                                            staticClass:
                                                              "form-control input-value",
                                                            attrs: {
                                                              id:
                                                                "adviser_name",
                                                              type: "text",
                                                              "aria-describedby":
                                                                "name-instructions",
                                                              name:
                                                                "adviser_name"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.referral
                                                                  .adviser.name
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.referral
                                                                    .adviser,
                                                                  "name",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "sr-only",
                                                              attrs: {
                                                                id:
                                                                  "name-instructions"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Please enter your name"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "referral.adviser_name"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('referral.adviser_name')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "referral.adviser_name"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 nofeedback-customspace mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for:
                                                                  "adviser_email"
                                                              }
                                                            },
                                                            [_vm._v("Email:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.referral
                                                                    .adviser
                                                                    .email,
                                                                expression:
                                                                  "referral.adviser.email",
                                                                modifiers: {
                                                                  trim: true
                                                                }
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required|email",
                                                                expression:
                                                                  "'required|email'"
                                                              }
                                                            ],
                                                            ref:
                                                              "adviser_email",
                                                            staticClass:
                                                              "form-control input-value",
                                                            attrs: {
                                                              id:
                                                                "adviser_email",
                                                              type: "text",
                                                              "aria-describedby":
                                                                "email-instructions",
                                                              name:
                                                                "adviser_email"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.referral
                                                                  .adviser.email
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.referral
                                                                    .adviser,
                                                                  "email",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "sr-only",
                                                              attrs: {
                                                                id:
                                                                  "email-instructions"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Please enter your email"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "referral.adviser_email"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('referral.adviser_email')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "referral.adviser_email"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _vm._m(9),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-sm-8" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label"
                                                            },
                                                            [_vm._v("Message")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height"
                                                            },
                                                            [
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .referral
                                                                        .message,
                                                                    expression:
                                                                      "referral.message"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "required|max:500",
                                                                    expression:
                                                                      "'required|max:500'"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  "aria-label":
                                                                    "Enter your personal message to the referral",
                                                                  rows: "7",
                                                                  maxlength:
                                                                    _vm.maxReferral,
                                                                  name:
                                                                    "message",
                                                                  placeholder:
                                                                    "[Click here to edit]\nI help students and alumni..."
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.referral
                                                                      .message
                                                                },
                                                                on: {
                                                                  keyup:
                                                                    _vm.countdownReferral,
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm.referral,
                                                                      "message",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "referral.message"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('referral.message')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "referral.message"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "char-counter template-subject-counter",
                                                                      class: {
                                                                        "char-count-error":
                                                                          _vm.exceedsMaxCountReferral
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.remainingCountReferral
                                                                        ) +
                                                                          "  / 500\n                                                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-12 col-sm-12 text-right"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn template-button submitBtn",
                                                                  style:
                                                                    _vm.styleObjectBtn,
                                                                  attrs: {
                                                                    type:
                                                                      "submit"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Share Request"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-sm-4"
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-sm-8"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  (_vm.success === false &&
                                    _vm.successReferral == false &&
                                    _vm.buttonText.search(
                                      /Not A Good Question/i
                                    ) == -1) ||
                                  (_vm.success &&
                                    _vm.successReferral == false &&
                                    _vm.action == "no" &&
                                    _vm.buttonText.search(
                                      /Not A Good Question/i
                                    ) == -1 &&
                                    _vm.memberid != "undefined" &&
                                      typeof _vm.memberid != "undefined" &&
                                      _vm.memberid != "null" &&
                                      _vm.memberid != "")
                                    ? _c("div", [
                                        !_vm.termsAndConditions ||
                                        _vm.action == "no"
                                          ? _c(
                                              "div",
                                              { staticClass: "row my" },
                                              [_vm._m(10)]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.termsAndConditions &&
                                        _vm.action == "yes"
                                          ? _c(
                                              "div",
                                              { staticClass: "row my" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-12" },
                                                  [
                                                    _vm.showTermsErrorMsg
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-center custom-action-ptext"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Please acknowledge that you have read our terms and conditions before proceeding."
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group disclaimer terms-conditions-box"
                                                      },
                                                      [
                                                        _c("md-checkbox", {
                                                          staticClass:
                                                            "form-control template-checkbox pt-0",
                                                          attrs: {
                                                            name:
                                                              "checkedTerms",
                                                            id: "checkedTerms"
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.saveChanges
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.checkedTerms,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.checkedTerms = $$v
                                                            },
                                                            expression:
                                                              "checkedTerms"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "html-disclaimer",
                                                          attrs: {
                                                            for: "checkedTerms"
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.community
                                                                .content
                                                                .termsAndConditionsMessage
                                                            )
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "email-request-review"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "template-request-review"
                                              },
                                              [
                                                _vm.createdByMember.first &&
                                                _vm.createdByMember.last
                                                  ? _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.createdByMember
                                                            .first +
                                                            " " +
                                                            _vm.createdByMember
                                                              .last
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.memberSchool
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "email-custom"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.memberSchool
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("h6", [
                                                  _vm._v(
                                                    _vm._s(_vm.ask.subject)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  { staticClass: "font-color" },
                                                  [_vm._v(_vm._s(_vm.ask.text))]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "list-inline text-center footer-links"
                              },
                              [
                                _c("li", [
                                  _vm.community.content &&
                                  _vm.community.content.landingPageURL &&
                                  _vm.community.content.landingPageURL.length
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "links",
                                          attrs: {
                                            tabindex: "0",
                                            href:
                                              _vm.community.content
                                                .landingPageURL,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Learn More")]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "javascript:void(0)",
                                            tabindex: "0"
                                          }
                                        },
                                        [_vm._v("Learn More")]
                                      )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm.community.content &&
                                  _vm.community.content.termsConditionsURL &&
                                  _vm.community.content.termsConditionsURL
                                    .length
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "links",
                                          attrs: {
                                            tabinex: "0",
                                            href:
                                              _vm.community.content
                                                .termsConditionsURL,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Terms Of Use [pdf]")]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "javascript:void(0)",
                                            tabindex: "0"
                                          }
                                        },
                                        [_vm._v("Terms Of Use [pdf]")]
                                      )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm.community.content &&
                                  _vm.community.content.unsubscribePageURL &&
                                  _vm.community.content.unsubscribePageURL
                                    .length
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            tabindex: "0",
                                            href:
                                              _vm.community.content
                                                .unsubscribePageURL,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("Opt Out")]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" }
                                        },
                                        [_vm._v("Opt Out")]
                                      )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "unsubscribe-community-logo email-actionpage-flogo"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://www.protopia.co",
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.footerLogoURL,
                                        alt:
                                          "Community Logo of " +
                                          _vm.community.content.parameter2
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("p", { staticClass: "text-center custom-content" }, [
        _vm._v(
          "Please suggest a physical or virtual meeting option that we can share with the community member."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-detection-text" }, [
      _c("strong", [_vm._v("No contact information detected")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Make it easy for people to connect with you: add your email, phone number, or scheduling link!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-detection-text" }, [
      _c("strong", [_vm._v("No contact information detected")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Make it easy for people to connect with you: add your email, phone number, or scheduling link!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("p", { staticClass: "text-center custom-action-ptext" }, [
          _vm._v(
            "Please enter your phone number below and we will forward it to the community member."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-4 update-profile-response-label",
        attrs: { "aria-live": "polite" }
      },
      [_c("label", { attrs: { for: "city-input-custom" } }, [_vm._v("City:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-4 update-profile-response-label",
        attrs: { "aria-live": "polite" }
      },
      [
        _c("label", { attrs: { for: "state-input-custom" } }, [
          _vm._v("State:")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-4 update-profile-response-label",
        attrs: { "aria-live": "polite" }
      },
      [
        _c("label", { attrs: { for: "country-input-custom" } }, [
          _vm._v("Country:")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Recipient")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Your Details")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Personal Message")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h2", { staticClass: "text-center email-request-title" }, [
        _vm._v("FYI, here's the request")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-620ad492", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620ad492","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomAction.vue
// module id = null
// module chunks = 